import invert from './invert.js';
import escapeMap from './_escapeMap.js';

// Internal list of HTML entities for unescaping.
export default invert(escapeMap);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/_unescapeMap.js
// module id = 823
// module chunks = 115